import { SWITCH_DUAL_LANGUAGE_GRADE } from '../actionTypes/shared/apiActionTypes';

const switchDualLanguageGrade = selectedGrade => ({
    type: SWITCH_DUAL_LANGUAGE_GRADE,
    selectedGrade,
});

export default switchDualLanguageGrade;
